import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Heart, ShoppingCart } from 'lucide-react';

/**
 * Template 5: TARA — Editorial Chic Product Card
 * Cream card, charcoal text, serif product names, hover lift
 */
const ProductCard = ({ product }) => {
    const navigate = useNavigate();

    return (
        <div className="group cursor-pointer">
            {/* Image Container */}
            <div
                className="relative overflow-hidden bg-[#F5F4F0] mb-3 md:mb-4"
                style={{ paddingBottom: '133.33%' }}
                onClick={() => navigate(`/template5/product/${product.id}`)}
            >
                <img
                    src={product.image}
                    alt={product.name}
                    className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />

                {/* Hover Overlay */}
                <div className="absolute inset-0 bg-[#1A1A1A]/0 group-hover:bg-[#1A1A1A]/10 transition-colors duration-500" />

                {/* Wishlist Button */}
                <button className="absolute top-3 right-3 md:top-4 md:right-4 w-8 h-8 md:w-9 md:h-9 bg-[#FAF9F6] flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-white">
                    <Heart size={15} className="text-[#2C2C2C]" />
                </button>

                {/* Quick Add */}
                <button
                    className="absolute bottom-3 left-3 right-3 md:bottom-4 md:left-4 md:right-4 bg-[#2C2C2C] text-white py-2.5 md:py-3 opacity-0 group-hover:opacity-100 transition-all duration-300 hover:bg-[#1A1A1A] flex items-center justify-center gap-2 text-[10px] md:text-xs tracking-[0.15em] uppercase"
                    style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                    <ShoppingCart size={14} />
                    Add to Cart
                </button>
            </div>

            {/* Product Info */}
            <div onClick={() => navigate(`/template5/product/${product.id}`)}>
                <h3
                    className="text-[#1A1A1A] text-base md:text-lg mb-1 group-hover:text-[#71717A] transition-colors duration-300"
                    style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 500 }}
                >
                    {product.name}
                </h3>
                {product.category && (
                    <p
                        className="text-[11px] md:text-xs text-[#71717A] tracking-[0.1em] uppercase mb-1.5"
                        style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 300 }}
                    >
                        {product.category}
                    </p>
                )}
                <div className="flex items-center gap-2">
                    <span
                        className="text-[#1A1A1A] text-sm md:text-base"
                        style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500 }}
                    >
                        {typeof product.price === 'number' ? `₹${product.price.toLocaleString('en-IN')}` : product.price}
                    </span>
                    {product.originalPrice && (
                        <span
                            className="text-[#71717A] text-xs md:text-sm line-through font-light"
                            style={{ fontFamily: "'Outfit', sans-serif" }}
                        >
                            {typeof product.originalPrice === 'number' ? `₹${product.originalPrice.toLocaleString('en-IN')}` : product.originalPrice}
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductCard;
